import React from 'react';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('AppErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
          <div className="w-full max-w-xl rounded-3xl border border-red-100 bg-white p-8 shadow-sm text-center">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-50 text-2xl">⚠️</div>
            <h1 className="text-2xl font-black text-gray-900">یک خطای غیرمنتظره رخ داد</h1>
            <p className="mt-3 text-sm leading-7 text-gray-600">
              برای حفظ پایداری سامانه، صفحه متوقف شد. با بارگذاری مجدد معمولاً مشکل برطرف می‌شود.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
              <button type="button" className="btn btn-primary" onClick={this.handleReload}>بارگذاری مجدد</button>
              <a href="/" className="btn btn-secondary">بازگشت به داشبورد</a>
            </div>
            {this.state.error?.message ? (
              <div className="mt-6 rounded-2xl border border-gray-100 bg-gray-50 p-4 text-right text-xs text-gray-500">
                {this.state.error.message}
              </div>
            ) : null}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
